import { ColumnApi as CoreColumnApi } from '@ag-grid-community/core';
import { ColumnApi } from 'ag-grid-community';

export function sanitizeFilterModel(filterModel: any, columnApi: ColumnApi | CoreColumnApi): any {
  const formattedFilterModels = {};

  Object.keys(filterModel).forEach((columnId) => {
    const currentModel = filterModel[columnId];
    const columnDef = columnApi.getColumn(columnId).getColDef();

    if (columnDef.floatingFilterComponentParams && columnDef.floatingFilterComponentParams.normalize) {
      formattedFilterModels[columnId] = {
        ...currentModel,
        filter: columnDef.floatingFilterComponentParams.normalize(currentModel.filter),
      };
    }
  });

  return formattedFilterModels;
}
